export const environment = {
	production: false,
	mailUrl: 'https://int-b.dev.tecalis.com/hermes/current/email',
	apiKey: 'hdJcQ5Zs-3iZB-hoOj-Zeqg-o4uS6Gvw6QIT',
};
